/**
 * The prototype's "now".
 *
 * Every date in the app is derived from this constant and never from the clock,
 * which is what makes two reloads produce identical figures — the determinism
 * requirement in prototype-plan.md's Verification section. `defaultDatePickerPresets()`
 * reads `new Date()` when called with no argument, so it is always passed this.
 *
 * It lives in its own module rather than in `generator.ts` (where the plan first
 * sketched it) because the app shell needs it in Phase 1, before any data code
 * exists, and a shell that imports the row generator just to label a date picker
 * would have the dependency backwards. `generator.ts` imports it from here.
 *
 * Local midnight, not UTC: `MentionRow.day` is `startOfDay(d).getTime()` and the
 * calendar components work in local time, so the corpus and the date pickers
 * have to agree on which midnight they mean.
 */
export const REFERENCE_DATE = new Date(2026, 8, 15);
